import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.toggleContainerClass = this.data.get("class") || "open"

    this.restoreState()
    this.recalculateAfterImages()
  }

  restoreState() {
    const truncateTextareaId = this.data.get("truncate-textarea-id")
    if (!truncateTextareaId) return

    if (localStorage.getItem(truncateTextareaId) === "open") {
      this.containerTarget.classList.add(this.toggleContainerClass)
    }
  }

  recalculateAfterImages() {
    const images = this.containerTarget.querySelectorAll("img")

    if (images.length === 0) {
      this.recalculate()
      return
    }

    let loaded = 0

    images.forEach((img) => {
      if (img.complete) {
        loaded++
      } else {
        img.addEventListener("load", () => {
          loaded++
          if (loaded === images.length) this.recalculate()
        })
      }
    })

    if (loaded === images.length) this.recalculate()
  }

  recalculate() {
    const maxHeight = 150

    if (this.containerTarget.scrollHeight <= maxHeight) {
      this.containerTarget.classList.add("no-truncation")
    } else {
      this.containerTarget.classList.remove("no-truncation")
    }
  }

  open() {
    this.containerTarget.classList.add(this.toggleContainerClass)
  }

  toggle() {
    this.containerTarget.classList.toggle(this.toggleContainerClass)

    const truncateTextareaId = this.data.get("truncate-textarea-id")
    if (!truncateTextareaId) return

    const isOpen = this.containerTarget.classList.contains(this.toggleContainerClass)
    localStorage.setItem(truncateTextareaId, isOpen ? "open" : "closed")
  }
}
